import React, { Component } from "react"
import "./About.css"

class About extends Component {
    render() {
        return (
            <div className="about">
                <div className="words">
                    <h2>About Me</h2>
                    <p>I hold a BM in Music Business from the University of Miami and an MM in Jazz Voice from Indiana University, and I'm a voting member of the Recording Academy. That foundation shapes how I approach every project, with an instinct for brand, audience, and the story a digital experience tells.
                        Most recently I spent five years at TransPerfect, growing from junior to senior developer on the Marketing and Communications team. I led web development from scoping requests through delivery — building responsive interfaces in React, Next.js, and TypeScript, architecting a shared component library across product teams, and working across CMS platforms like WordPress and Drupal. One redesign I led cut page load time by 40%.</p>
                    <p>I'm currently open to new opportunities where I can contribute to a strong engineering or digital team. If you're looking for a developer who's comfortable owning projects from brief to launch, let's connect.</p>
                </div>
                <a href="/jake-pressman-resume.pdf" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "black" }}><img className="resume" src="/jake-pressman-resume.png" alt="resume" /><p>Click Here to View My Resume</p></a>
            </div>
        )
    }
}

export default About
